
  //wimlogic wish functions

  showWishCount = function (count){
  var sumHtml='<div class="wish-count-bubble"><span aria-hidden="true">'+count+'</span><span class="visually-hidden">'+count+'</span></div>';
              $("#wim-wish-summary .wish-count-bubble").remove();
  
              if(count > 0){
                $("#wim-wish-summary").append(sumHtml);
              }
              
  $("#wish-toast-wapper #wish-notification-button").html("View my links ("+count+")");
  }
 
  ajaxLoadWishItem = function (handle,type){
    var url = "https:"+"//"+window.location.host+"/products/"+handle+".js";
    $.ajax({
            type:'GET',
            url : url,
            dataType : 'json',
            success  : function(data) {
             if(type=="remove"){
              $("#wish-toast-wapper .wish-notification__heading span").html("Item remove from your likes");
             }else{
              $("#wish-toast-wapper .wish-notification__heading span").html("Item added to your likes");
             }
             var prodHtml='<div class="wish-notification-product__image img-media">'
          +'<img src="'+data.featured_image+'?width=140" alt="" width="70" height="70" >'
         +'</div><div><h3 class="wish-notification-product__name h4">'+data.title+'</h3></div>';
                 $("#wish-toast-wapper .wish-notification-product").html(prodHtml);
               $("#wish-toast-wapper").toast('show');
            },
            error : function() {
            }
     });
  }
  loadWishPage = function (data){
       
    var boxObj = $(".wishlist-wapper");
   if(boxObj.length > 0){
       $.each(data,function(k1,handle){
            var url = "https:"+"//"+window.location.host+"/products/"+handle+".js";
    $.ajax({
            type:'GET',
            url : url,
            dataType : 'json',
            success  : function(product) {
               var liHtml=$(".wishlist-wapper-hide").html();
              liHtml=liHtml.replace(/{product.title}/g,product.title)
                 .replace(/{product.compare_at_price}/g,product.compare_at_price/100)
                 .replace(/{product.price}/g,product.price/100)
                 .replace(/{product.featured_media}/g,product.featured_image+"?width=450")
                 .replace(/{product.url}/g,product.url)
                 .replace(/\{\{amount\}\}/g,'')
                 ;
         
               boxObj.find(".product-grid").append(liHtml);
            },
            error : function() {
            }
     });// end ajax
       });
   }
    //endif boxObj
  }
  loadWishItemList = function (obj){
   
   var boxObj=obj.find(".wim-wish-box");
   if(boxObj.length > 0){
      var oneObj =boxObj.first();
      var url="https://wimlogic.com/wim/app/web/wish/get-all?shop="+oneObj.attr("data-shop")+"&custId="+oneObj.attr("data-cust");
      
      
      $.ajax({
            type:'GET',
            url : url,
            dataType : 'jsonp',
            jsonp:"jsoncallback",
            success  : function(data) {
              showWishCount(data.res.length)
              $.each(data.res,function(k1,v1){
                  obj.find(".wim-wish-box[data-handle='"+v1+"']").addClass("active");
              });
              if (data.res.length > 0){
                 loadWishPage(data.res);
             }else{
                $(".wishlist-wapper").append('<div class="title-wrapper center"><h2 class="title title--primary">No products found</h2></div>');
                
             }
              
             
            },
            error : function() {
            }
     });
   }// endif
  }//end loadWishItem
   
 addWishItem = function (){
  $("body").on("click","#add-wish-btn",function(){
    var oneObj =$(this);
    if(oneObj.hasClass("active")){
       var url="https://wimlogic.com/wim/app/web/wish/del?shop="+oneObj.attr("data-shop")+"&custId="+oneObj.attr("data-cust")+"&productId="+oneObj.attr("data-id")+"&handle="+oneObj.attr("data-handle");
       
    }else{
      var url="https://wimlogic.com/wim/app/web/wish/add?shop="+oneObj.attr("data-shop")+"&custId="+oneObj.attr("data-cust")+"&productId="+oneObj.attr("data-id")+"&handle="+oneObj.attr("data-handle");
    }
    var handle = oneObj.attr("data-handle");
    oneObj.find("svg").addClass("hide");
    oneObj.find(".spinner-box").remove();
    var loading='<div class="spinner-box"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>';
    oneObj.append(loading);
    $.ajax({
            type:'GET',
            url : url,
            dataType : 'jsonp',
            jsonp:"jsoncallback",
            success  : function(data) {
             showWishCount(data.res.length)
              var has = 0;
              
              $.each(data.res,function(k1,v1){
                if(v1 == handle){
                  has ++;
                }
              });
               oneObj.find(".spinner-box").remove();
               oneObj.find("svg").removeClass("hide");
               if(has == 0){
                oneObj.removeClass("active");
                ajaxLoadWishItem(handle,"remove");
              }else{
                oneObj.addClass("active");
                ajaxLoadWishItem(handle,"add");
              }
              
            },
            error : function() {
            }
     });
  });
  
  }//end addWishItem
  
//wimlogic review functions
loadReviewStar = function(obj){
  var len=obj.find(".wim-review-box").length;
  
  if(len > 0){
      var groupStr="";
      var hasArr=new Array();
      var v;
      var idStr="";
      var reviewBox=obj.find(".wim-review-box");
      $.each(reviewBox,function(){
         v=$(this).attr("data-group");
        if(v==""){
          idStr+=$(this).attr("data-product_id")+",";
        }else{
           if($.inArray(v,hasArr)==-1){
            groupStr+=v+",";
            hasArr.push(v);
        }
        }
      });

     if(groupStr!=''){
       var url="https://wimlogic.com/wim/app/web/s-review/bulk-star-bg?key=pk_754599472afee027f7f314f4440678b35e85edc613f25402de187498aa052a96&group="+groupStr;
      $.ajax({
            type:'GET',
            url : url,
            dataType : 'jsonp',
            jsonp:"jsoncallback",
            success  : function(data) {
              $.each(data.html,function(k1,v1){
                  obj.find(".wim-review-box[data-group='"+k1+"']").html(v1);
              });
             
            },
            error : function() {
            }
     });
    }

    if(idStr!=''){
       var url="https://wimlogic.com/wim/app/web/s-review/bulk-star-bg?key=pk_754599472afee027f7f314f4440678b35e85edc613f25402de187498aa052a96&id="+idStr;
      $.ajax({
            type:'GET',
            url : url,
            dataType : 'jsonp',
            jsonp:"jsoncallback",
            success  : function(data) {
              $.each(data.html,function(k1,v1){
                  obj.find(".wim-review-box[data-product_id='"+k1+"']").html(v1);
              });
             
            },
            error : function() {
            }
     });
    }
    
  }
}

//list all reviews
loadReviewList = function(page){
    var len=$(".wim-review-list-box").length;
    
    if(len > 0){
       var url;
        var thisObj=$(".wim-review-list-box");
        thisObj.find(".wim-review-list-page").html("");
        url="https://wimlogic.com/wim/app/web/s-review/list-bg?key=pk_754599472afee027f7f314f4440678b35e85edc613f25402de187498aa052a96&product_id="+thisObj.attr("data-product_id")+"&page="+page;
          $.ajax({
            type:'GET',
            url : url,
            dataType : 'jsonp',
            jsonp:"jsoncallback",
            success  : function(data) {
              if(data.page==1){
                thisObj.find(".wim-review-list-head-box").html(data.head);
                thisObj.find(".wim-review-list-body").html(data.body);
                thisObj.find(".wim-review-list-page").html(data.next);
                //$(".wim-review-list-box .wim-review-list-content > div").last().find("a[data-toggle='popover']").popover({"html":true});
              }else{
                thisObj.find(".wim-review-list-body").append(data.body);
                thisObj.find(".wim-review-list-page").html(data.next);
                //$(".wim-review-list-box a[data-toggle='popover']").popover('show');
              }
              $(".wim-review-list-box .wim-review-list-content a[data-toggle='popover'] ").popover({"html":true});
              //$(".wim-review-list-box .wim-review-list-content a[data-toggle='modal'] ").modal();
               
            },
            error : function() {
                
            }
     });
     
  }
    
  } 


loadGroupColor = function(obj){
  var len=obj.find(".group-color-box").length;
  if(len > 0){
      var groupStr="";
      var handles=[];
      var url;
     
      var groupBox=obj.find(".group-color-box");
      $.each(groupBox,function(){
        var group=$(this).attr("data-group");
        if(group!="") {
        var collection=$(this).attr("data-collection");
       
        if($.inArray(group, handles)==-1){
             handles.push(group);
             if(typeof(collection)=="undefined"){
              url="/collections/all/item_"+group+"?view=color";
            }else{
              url="/collections/"+collection+"/item_"+group+"?view=color";
            }

          $.get(url,function(html){
             obj.find(".group-color-box[data-group='"+group+"']").html(html);
                       
             },"html");
          }
      }
        });
     
  }
}

goDropdownLink = function(){
  $(".dropdown .dropdown-menu button").click(function(){
     var params = $(this).attr("data-params");
     if(typeof(params)!="undefined"){
        var link = window.location.hash+"//"+window.location.host + window.location.pathname + params;
     }else{
       var link = $(this).attr("data-href");
     }
    
     if(typeof(link)!="undefined"){
       window.location.href=link;
     }
    
  });
 
}
goDropdownLink();

ajaxLoadPage=function(){
 
  $("body").on("click","#ajax-pagination-btn",function(){
 
    //$(this).attr("disabled",true);
    $(this).find(".spinner-border-btn").addClass("spinner-border");
    var link = $(this).attr("data-href")+"&view=none";
   
    $.ajax({
            type:'GET',
            url : link,
            dataType : 'html',
            success  : function(data) {
              $(".ajax-pagination-wapper").empty();
              //$(".ajax-pagination-wapper").last().addClass("hide");
              $(".product-grid").after(data);
              loadReviewStar($(".product-grid").last());
              loadGroupColor($(".product-grid").last());
            },
            error : function() {
                
            }
     });
  });
}

ajaxLoadPage();

hoverProductImage=function(){
  $("body").on("mouseover",".product-grid .group-color-box a",function(){
    var imgUrl = $(this).find("img").last().attr("src");
    var parentObj = $(this).parents(".card-wrapper").find(".media");
    
    parentObj.append("<img class='color-hover-img' src='"+imgUrl+"'/>");
   // parentObj.find("img").last().css("opacity",1);
    parentObj.find("img").first().addClass("hide");
   
  });

  $("body").on("mouseout",".product-grid .group-color-box a",function(){
    var parentObj = $(this).parents(".card-wrapper").find(".media");
    parentObj.find("img").first().removeClass("hide");
    parentObj.find(".color-hover-img").remove();
    
  });
}
hoverProductImage();

hoverProductImageZoom=function(){
  $("body").on("mouseover","fieldset .group-color-box a",function(){
    var imgUrl = $(this).find("img").last().attr("src");
    var parentObj = $(this).parents(".product").find(".product__media");
    parentObj.find("img").first().addClass("hide");
    parentObj.append("<img class='color-hover-img' src='"+imgUrl+"'/>");
  
    
   
  });

  $("body").on("mouseout","fieldset .group-color-box a",function(){
    var parentObj = $(this).parents(".product").find(".product__media");
    parentObj.find("img").first().removeClass("hide");
    parentObj.find(".color-hover-img").remove();
    
  });
}
hoverProductImageZoom();
ajaxLoadRelatePage=function(){
   var obj =$("#related-products-wapper product-recommendations");
  if(obj.length > 0){
     var link = obj.attr("data-url");
    $.ajax({
            type:'GET',
            url : link,
            dataType : 'html',
            success  : function(data) {
              var html=$(data).find("#related-products-wapper product-recommendations").html()
              obj.html(html);
              loadReviewStar(obj);
              loadGroupColor(obj);
            },
            error : function() {
                
            }
     });
  }
}

ajaxLoadProductDetail = function(){
 $("body").on("click",".product .group-color-box a",function(event){
   event.preventDefault();
   var url = $(this).attr("href");
   var obj=$(this).parents(".product");
   var loading='<div class="spinner-box"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>';
    $(this).append(loading);
    $.ajax({
            type:'GET',
            url : url,
            dataType : 'html',
            success  : function(data) {
              var html=$(data).find(".product").html()
              var modalHtml=$(data).find("product-modal").html();
              obj.html(html);
              
              $("product-modal").html(modalHtml);
              loadGroupColor(obj);
              Shopify.PaymentButton.init();
              loadWishItemList(obj);
            },
            error : function() {
                
            }
     });
 })
  
}
